import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useTheme } from '@mui/system';
import { fetchLocations, fetchShipmentAndDelivery, fetchMetricsByIdentifier, fetchEventsAndLogs } from '#action/shipment/overview';
import { fetchMeta } from '#action/meta/device';
import { fetchShipmentFiles } from '#action/shipment/files';
import { fetchCargoFiles } from '#action/shipment/shipment-delivery-cargo';
import { getShipmentStatus } from '#component/shipment/helper';
import useWidth from '#hooks/useWidth';
import ShipmentOverview from './overview';

function WidthWrapper(props) {
  const width = useWidth();
  const theme = useTheme();
  return <ShipmentOverview {...props} width={width} theme={theme} />;
}

function mapStateToProps(state) {
  const {
    shipment,
    dispatch,
    account,
    meta,
    copiedShipment
  } = state;

  return {
    shipment: { ...shipment, shipmentStatus: getShipmentStatus(shipment) },
    dispatch,
    account,
    meta,
    copiedShipment
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    fetchShipmentAndDelivery: id => dispatch(fetchShipmentAndDelivery(id)),
    fetchShipmentEvents: shipmentId =>
      dispatch(fetchEventsAndLogs(shipmentId)),
    fetchMetricsByIdentifier: (devices, period, identifier) =>
      dispatch(fetchMetricsByIdentifier(devices, period, identifier)),
    fetchLocations: (devices, period) =>
      dispatch(fetchLocations(devices, period)),
    fetchMeta: () => dispatch(fetchMeta()),
    fetchShipmentFiles: id => dispatch(fetchShipmentFiles(id)),
    fetchCargoFiles: id =>
      dispatch(fetchCargoFiles(id))
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(WidthWrapper);
